// eslint-disable-next-line import/named
import APIConfirmTransfer from "./APIConfirmTransfer";
import APIDestinationAccount from "./APIDestination";
import APISourceAccount from "./APISourceAccount";
import APITransfer from "./APITransfer";
import { create } from "axios";
import CoreAPI from "./coreAPI";
import {
  citizenshipResponse,
  emptyTransferResponse,
  mockDestinationResponse,
  mockEmployerSearchResponse,
  mockProviderResponse,
  mockSourceAccountRes,
  mockTransferInitiateResponse,
  stateResponse,
  suffixResponse,
  userDetailsRes,
} from "./mockAPIResponse";
import UserDetails, { UserDetailsResponse } from "../class/userDetails";
import SourceAccount, { SourceAccountResponse } from "../class/sourceAccount";
import { TransferResponse } from "../class/transferDetails";
import APIEmployer from "./APIEmployer";

const createAuthAPIInstance = (token: string) => {
  const axiosInstance = create({
    baseURL: process.env.NODE_ENV === "test" ? "" : process.env.REACT_APP_API_BASE_URL,
    timeout: 3000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const coreAPI = new CoreAPI(axiosInstance);

  return {
    confirmTransfer: APIConfirmTransfer(coreAPI),
    sourceAccount: APISourceAccount(coreAPI),
    destinationAccount: APIDestinationAccount(coreAPI),
    transfer: APITransfer(coreAPI),
  };
};

const createEmployerAPIInstance = () => {
  const axiosInstance = create({
    baseURL: process.env.NODE_ENV === "test" ? "/" : process.env.REACT_APP_EMPLOYER_SEARCH_BASE_API_URL,
    timeout: 3000,
  });
  const coreAPI = new CoreAPI(axiosInstance);

  return {
    employer: APIEmployer(coreAPI),
  };
};

export { createAuthAPIInstance, createEmployerAPIInstance };

export const createDemoAPIInstance = () => {
  return {
    confirmTransfer: {
      async getUserDetails(): Promise<UserDetailsResponse> {
        return userDetailsRes;
      },
      async updateUserDetails({
        userDetails,
      }: {
        userId: string;
        userDetails: UserDetails;
      }): Promise<UserDetailsResponse> {
        return userDetails as UserDetailsResponse;
      },
      async getCountriesList(): Promise<string[]> {
        return citizenshipResponse;
      },
      async getStatesList(): Promise<string[]> {
        return stateResponse;
      },
      async getSuffixList(): Promise<string[]> {
        return suffixResponse;
      },
      async uploadSignature() {
        return true;
      },
      async initiateTransfer(): Promise<TransferResponse> {
        return mockTransferInitiateResponse;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      async getTransferInstructions({ userId }: { userId: string }): Promise<any> {
        return [];
      },
      async schedulePhoneCall() {
        return true;
      },
    },
    sourceAccount: {
      async getSourceAccountsByTransferId() {
        return mockSourceAccountRes;
      },
      async createOrUpdateSourceAccount({
        sourceAccount,
      }: {
        sourceAccount: SourceAccount;
      }): Promise<SourceAccountResponse> {
        return {
          ...mockSourceAccountRes,
          ...sourceAccount,
          transferId: 123,
          sourceAccountId: 123,
        } as SourceAccountResponse;
      },
      async uploadStatement() {
        return true;
      },
      async removeSourceAccount() {
        return true;
      },
    },
    destinationAccount: {
      async getDestinationAccountByTransferId() {
        return mockDestinationResponse;
      },
      async createDestinationAccount() {
        return mockDestinationResponse;
      },
    },
    transfer: {
      async getInProgressTransfer() {
        return [];
      },
      async createNewTransfer() {
        return emptyTransferResponse;
      },
      async getTransferDetailsById() {
        return emptyTransferResponse;
      },
    },
    employer: {
      async fetchEmployersList() {
        return mockEmployerSearchResponse;
      },
      async findProviderByEmployerId() {
        return mockProviderResponse;
      },
    },
  };
};
